<template>
  <a-layout class="home">
    <a-layout-sider
      :collapse="collapsed"
      :collapsedWidth="collapsedWidth"
      :trigger="trigger"
      @collapse="collapseMenu"
      class="sider main-sider"
      collapsible
      v-model="collapsed"
    >
      <div :class="{ collapsed: collapsed }" class="logo"></div>
      <a-menu
        :selectedKeys="selectedKeys"
        @openChange="onOpenChange"
        class="menu"
        mode="inline"
        theme="dark"
      >
        <template v-for="item in menu">
          <a-menu-item
            :key="item.path"
            @click="menuClick(item)"
            v-if="!item.children"
          >
            <i :class="item.icon"></i>
            <span>{{ item.name }}</span>
          </a-menu-item>
          <a-sub-menu :key="item.path" v-else>
            <span slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.name }}</span>
            </span>
            <template v-for="subItem in item.children">
              <template v-if="subItem.children">
                <a-sub-menu :key="subItem.path">
                  <span slot="title">
                    <span style="padding-left: 32px !important">
                      {{ subItem.name }}
                    </span>
                  </span>
                  <a-menu-item
                    :key="subItem1.path"
                    @click="keepOpenKeys1(item, subItem, subItem1)"
                    v-for="subItem1 in subItem.children"
                    >{{ subItem1.name }}</a-menu-item
                  >
                </a-sub-menu>
              </template>
              <a-menu-item
                :key="subItem.path"
                @click="keepOpenKeys(item, subItem)"
                v-else
              >
                <span>{{ subItem.name }}</span>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </template>
      </a-menu>
    </a-layout-sider>
    <a-layout class="main">
      <a-layout-header
        :class="{ 'main-header': $route.name == 'overview' }"
        class="header"
      >
        <a-icon
          :type="collapsed ? 'menu-unfold' : 'menu-fold'"
          @click="collapseMenu"
          class="trigger"
        />
        <div class="main-head">
          <div class="top-nav-content">
            <a
              class="help"
              href="https://zyun.360.cn/developer/doc?did=xacpjj"
              target="blank"
              >帮助支持</a
            >
            <a class="about" href="https://zyun.360.cn/aboutus" target="blank"
              >关于我们</a
            >
            <span @click="toMessage" class="message" v-if="msgVisible">
              <a-badge :count="$store.state.msgCount" class="msg-icon"
                >消息</a-badge
              >
            </span>
          </div>
          <div class="company-content">
            <div class="company-select">
              <p :key="item.qid" class="company-select-item" v-for="item in d">
                <span class="company-select-name" v-if="item.qid == m">
                  <heart-icon v-if="item.is_owner == 1" />
                  <user-icon v-else />
                  {{ item.enterprise_name }}
                  <a-tag color="orange" v-if="item.is_owner == 1">拥有者</a-tag>
                  <a-icon class="icon-down" type="down" />
                </span>
              </p>
            </div>
            <div class="company-list">
              <span class="company-id">企业账号：</span>
              <p
                :key="item.qid"
                @click="boxChange(item.qid)"
                class="company-item"
                v-for="item in d"
              >
                <heart-icon v-if="item.is_owner == 1" />
                <user-icon v-else />
                {{ item.enterprise_name }}
                <a-tag color="orange" v-if="item.is_owner == 1">拥有者</a-tag>
              </p>
            </div>
          </div>
          <!-- <a-select
            :default-value="m"
            @change="boxChange"
            class="main-select"
            style="margin-right: 10px"
            v-if="d && m"
          >
            <a-select-opt-group>
              <span slot="label">企业账号：</span>
              <a-select-option :key="t.qid" :value="t.qid" v-for="t in d">
                <heart-icon v-if="t.is_owner == 1" />
                <user-icon v-else />
                {{ t.enterprise_name || t.qid }}
                <a-tag color="orange" v-if="t.is_owner == 1">拥有者</a-tag>
                <a-tag color="green" v-if="t.user_level == 1"> 试用 </a-tag>
              </a-select-option>
            </a-select-opt-group>
          </a-select>-->
          <div class="main-head-popover">
            <a-avatar
              :src="avatar"
              icon="user"
              style="
                width: 32px;
                height: 32px;
                line-height: 32px;
                border: 0;
                background: 0;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                cursor: pointer;
                padding: 0;
              "
            />
            <div class="main-head-hover" v-show="showPanel">
              <div class="main-head-hover-1">
                <a-avatar :src="avatar" icon="user" />
                <span>{{ userName }}</span>
              </div>
              <div class="main-head-hover-2">
                版本信息：
                <a-tag color="orange" v-if="user.user_level == 1">试用版</a-tag>
                <a-tag color="green" v-else-if="user.user_level == 2"
                  >正式版</a-tag
                >
                <a-tag color="gray" v-else>未知版</a-tag>
              </div>
              <div class="main-head-hover-3">
                到期时间：{{ user.expire_time }}
                <a-tag
                  color="gray"
                  style="margin-left: 10px"
                  v-if="user.expire_status == 3"
                  >已过期</a-tag
                >
                <a-tag
                  color="orange"
                  style="margin-left: 10px"
                  v-if="user.expire_status == 2"
                  >即将到期</a-tag
                >
              </div>
              <div class="main-head-hover-4">
                边缘服务器激活码可用数：{{ user.surplus_count }}
              </div>
              <!-- <a @click="confirm" class="main-head-hover-5" href="#">退出账号</a> -->
            </div>
          </div>
          <i class="main-head-line">|</i>
          <a-popconfirm
            @cancel="cancel"
            @confirm="confirm"
            cancel-text="取消"
            ok-text="退出"
            title="确认退出当前账号吗?"
          >
            <a class="main-head-quit" href="#">退出</a>
          </a-popconfirm>
        </div>
      </a-layout-header>
      <a-layout-content class="main-container">
        <router-view ref="container" v-if="showPage && isRouterAlive" />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import global from "../../utils/Global";
import skillList from "../../utils/skill_config";

var infos = [];
// for (var i = 0; i < global.menuInfo.length; i++) {
//   if (global.menuInfo[i].index < 100) {
//     infos.push(global.menuInfo[i])
//   }
// }

const HeartIcon = {
  template: `
    <a-icon :component="HeartSvg" />
  `,
  data() {
    return {
      HeartSvg,
    };
  },
};
const centerIcon = {
  template: `
    <a-icon :component="centerSvg" />
  `,
  data() {
    return {
      centerSvg,
    };
  },
};
const centerSvg = {
  template: `
    <svg t="1608174915464" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2718" width="200" height="200"><path d="M680.416757 459.07972 573.090357 459.07972 573.090357 351.753319c0-30.312376-24.800849-55.113225-55.113225-55.113225l0 0c-30.312376 0-55.113225 24.800849-55.113225 55.113225l0 107.326401L355.537506 459.07972c-30.312376 0-55.113225 24.800849-55.113225 55.113225l0 0c0 30.312376 24.800849 55.113225 55.113225 55.113225l107.326401 0 0 107.326401c0 30.312376 24.800849 55.113225 55.113225 55.113225l0 0c30.312376 0 55.113225-24.800849 55.113225-55.113225L573.090357 569.30617l107.326401 0c30.312376 0 55.113225-24.800849 55.113225-55.113225l0 0C735.529983 483.880569 710.729134 459.07972 680.416757 459.07972z" p-id="2719" fill="#1afa29"></path><path d="M511.771803 76.893274c-239.630682 0-435.106726 195.47195-435.106726 435.103656 0 94.841042 30.642904 182.753277 82.499969 254.379595 13.024641 20.517289 32.243355 42.841737 59.010999 66.24168 77.483722 71.033823 180.62787 114.488521 293.595758 114.488521 103.163591 0 198.122313-36.252669 272.847202-96.638991 0.907673-0.728594 1.814322-1.456165 2.716878-2.192945 0.475837-0.38988 0.954745-0.775666 1.425466-1.165546 22.744004-18.662035 43.799552-39.940664 62.682621-63.755046 59.665915-74.495668 95.433536-168.876222 95.433536-271.356244C946.877505 272.370341 751.405555 76.893274 511.771803 76.893274zM829.009004 763.432473c-66.787102 37.028335-141.208069 57.060577-188.409091 66.422805-90.930989 18.152429-200.3654-12.568247-240.679571-31.591509-68.068282-32.116465-89.183182-64.577784-124.267235-97.739045l-20.070104-19.195178c-47.562249-44.911886-98.123808-39.531342-113.870444-4.776793-22.51069-50.329269-35.056424-106.024755-35.056424-164.555823 0.001023-92.624561 31.394011-178.147376 84.049255-246.521626 68.905346-40.120766 147.548474-61.442374 196.569958-71.193459 91.102904-18.147312 200.535269 12.568247 240.679571 31.592532 68.240197 32.115442 89.182158 64.576761 124.43915 97.91403l20.070104 19.023262c47.082318 44.544519 95.120404 38.818097 109.209284 4.267187 22.610974 50.424436 35.21299 106.243743 35.21299 164.91705C916.885424 606.854345 883.972826 694.26516 829.009004 763.432473z" p-id="2720" fill="#1afa29"></path></svg>
    `,
};
const HeartSvg = {
  template: `
    <svg t="1608176020226" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2849" width="200" height="200"><path d="M1000.102712 846.937125L986.516554 898.384709c-4.994911 18.980662-24.375166 30.169263-43.25593 24.974556l-11.488296-3.096845c-4.795115 6.493384-9.989822 12.786972-15.883817 18.680967-2.79715 2.79715-5.893995 4.994911-8.791044 7.592265 0.399593 0.899084 1.09888 1.69827 1.398576 2.697252l4.695216 17.082596c5.194708 18.880764-5.893995 38.261019-24.674861 43.156032l-50.948093 13.386362c-18.780866 4.895013-38.161121-6.393486-43.355828-25.274251l-2.79715-10.389415c-20.678932-0.799186-41.257966-4.994911-60.638221-13.386361l-8.591247 8.591247c-13.785955 13.885853-36.163156 13.785955-50.049009-0.099898l-37.561732-37.761528c-13.885853-13.885853-13.885853-36.362953-0.099898-50.248806l8.591247-8.591247c-6.593283-15.18453-10.68911-31.068347-12.687074-47.251859l-11.78799-3.196743c-18.880764-5.094809-30.169263-24.674861-25.074454-43.555625L606.903311 740.245824c4.994911-18.980662 24.375166-30.169263 43.25593-24.974556l11.488295 3.096845c4.795115-6.493384 9.989822-12.786972 15.883818-18.680967 8.890942-8.99084 18.780866-16.28341 29.070382-22.776795l-1.298677-4.595318c-5.194708-18.880764 5.893995-38.261019 24.674861-43.156032l50.948093-13.386361c18.780866-4.895013 38.161121 6.393486 43.355829 25.27425l3.596336 13.386361c11.887888 2.297659 23.57598 5.494402 34.864479 10.389415l8.591247-8.591247c13.785955-13.885853 36.163156-13.785955 50.049009 0.099899l37.561732 37.761527c13.885853 13.885853 13.885853 36.362953 0.099898 50.248806l-8.591247 8.591247c6.593283 15.18453 10.68911 31.068347 12.687074 47.251859l11.78799 3.196743c18.880764 5.094809 30.169263 24.674861 25.174352 43.555625zM796.610034 716.969538c-56.442495 0-102.195881 45.753386-102.195881 102.195881s45.753386 102.195881 102.195881 102.195881S898.805915 875.607915 898.805915 819.165419c0.099898-56.442495-45.753386-102.195881-102.195881-102.195881zM776.130899 553.436149c0 22.576998-18.281375 40.858373-40.858373 40.858373-12.187583 0-22.976591-5.394504-30.468958-13.885853l-0.899084 1.198779c-57.641274-31.068347-123.474202-48.650434-193.502856-48.650434-225.86988 0-408.98332 183.113441-408.98332 408.98332 0 22.576998-18.281375 40.858373-40.858373 40.858373-22.576998 0-40.858373-18.281375-40.858372-40.858373 0-214.681279 138.059343-396.695839 330.163623-463.327953-63.834964-48.550536-105.192828-125.172472-105.192828-211.584434 0-146.850386 118.978782-265.929067 265.829169-265.929067s265.829168 119.07868 265.829168 265.929067c0 86.411962-41.357864 162.934-105.192828 211.584434 28.67079 9.989822 56.042902 22.776795 82.016441 37.561731l-0.299695 0.299695c13.686056 6.593283 23.276286 20.579034 23.276286 36.962342z m-81.716746-286.308304c0-101.596492-82.416033-184.012525-184.012525-184.012524-101.596492 0-184.012525 82.416033-184.012524 184.012524 0 101.596492 82.416033 184.012525 184.012524 184.012525 101.596492 0 184.012525-82.416033 184.012525-184.012525z" p-id="2850"></path></svg>
  `,
};
const userIcon = {
  template: `
    <a-icon :component="UserSvg" />
  `,
  data() {
    return {
      UserSvg,
    };
  },
};
const UserSvg = {
  template: `
    <svg t="1608012688069" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5240" width="200" height="200"><path d="M494.884571 535.478857a431.396571 431.396571 0 0 1 430.957715 430.957714 40.155429 40.155429 0 1 1-80.310857 0A351.085714 351.085714 0 0 0 494.884571 615.862857a351.085714 351.085714 0 0 0-350.573714 350.646857 40.228571 40.228571 0 0 1-80.457143 0 431.396571 431.396571 0 0 1 431.030857-430.957714z m0-514.340571a257.170286 257.170286 0 0 1 256.877715 256.950857 257.170286 257.170286 0 0 1-256.877715 256.877714 257.170286 257.170286 0 0 1-256.877714-256.877714A257.170286 257.170286 0 0 1 494.884571 21.138286z m0 80.384a176.786286 176.786286 0 0 0-176.566857 176.566857 176.713143 176.713143 0 0 0 176.566857 176.493714A176.713143 176.713143 0 0 0 671.451429 278.089143a176.786286 176.786286 0 0 0-176.566858-176.566857z" p-id="5241"></path></svg>
  `,
};

var ua = navigator.userAgent.toLowerCase();
var isSafari = ua.match(/version\/([\d.]+).*safari/);

export default {
  components: {
    HeartIcon,
    userIcon,
    centerIcon,
  },
  props: {
    m: null,
    d: null,
    showPage: false,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      user: {},
      isManager: false,
      menuInfo: infos,
      menuIndex: 0,
      mWidth: 0,
      userName: global && global.userInfo ? global.userInfo.nickname : null,
      avatar: global && global.userInfo ? global.userInfo.img_url : null,
      showPanel: false,
      collapsed: false, // 导航收起状态
      collapsedWidth: 60, // 导航收缩宽度，设置为0时会出现特殊trigger
      trigger: null, // 自定义trigger，设置为null时隐藏trigger
      selectedKeys: [""], // 当前选中的菜单项
      openKeys: [""], // 当前展开的菜单项
      keepKeys: [""], // 当导航状态（展开-收起）改变时，保存当前选中的菜单项
      menu: [
        // 导航菜单
        {
          index: 0,
          path: "overview",
          name: "总览",
          icon: "iconfont icon-zonglan",
          roles: ["admin"],
        },
        {
          index: 1,
          path: "device",
          name: "设备管理",
          icon: "iconfont icon-shebeiguanli",
          roles: ["admin"],
          children: [
            { index: 101, path: "sever", name: "AI服务器", roles: ["admin"] },
            {
              index: 102,
              path: "camera",
              name: "摄像头设备",
              roles: ["admin"],
            },
            { index: 103, path: "group", name: "设备分组", roles: ["admin"] },
          ],
        },
        {
          index: 2,
          path: "live",
          name: "实时监控",
          icon: "iconfont icon-shishijiankong",
          roles: ["admin"],
        },
        {
          index: 3,
          path: "event",
          name: "事件管理",
          icon: "iconfont icon-shijianguanli",
          roles: ["admin"],
          children: [],
        },
        {
          index: 5,
          path: "template",
          name: "模板管理",
          icon: "iconfont icon-Template",
          roles: ["editor"],
          children: [
            {
              index: 901,
              path: "screenshot-template-list",
              name: "截图模板",
              roles: ["admin"],
            },
            {
              index: 902,
              path: "ai-template-list",
              name: "AI模板",
              roles: ["admin"],
            },
          ],
        },
        {
          index: 99,
          path: "data-center",
          name: "数据中心",
          icon: "iconfont icon-shijian",
          roles: ["admin"],
        },
        {
          index: 999,
          path: "alarm-time",
          name: "告警事件",
          icon: "iconfont icon-shijianguanli",
          roles: ["admin"],
        },
        {
          index: 250,
          path: "structured-libs-list",
          name: "结构化库",
          icon: "iconfont icon-jinengzhongxin",
          roles: ["admin"],
        },
        {
          index: 16,
          path: "ai-plugin",
          name: "AI插件管理",
          icon: "iconfont icon-Template",
          roles: ["editor"],
          children: [
            {
              index: 802,
              path: "custom-public-plugin",
              name: "公共插件",
              roles: ["admin"]
            },
            {
              index: 801,
              path: "custom-plugin-list",
              name: "我的插件",
              roles: ["admin"]
            }
          ]
        },
        {
          index: 711,
          path: "lib-management",
          name: "库管理",
          icon: "iconfont icon-Template",
          roles: ["admin"],
          children: [
            {
              index: 70111,
              path: "vector-lib",
              name: "向量库",
              roles: ["admin"],
            },
            {
              index: 702,
              path: "id-lib",
              name: "ID库",
              roles: ["admin"],
            },
          ],
        },
        {
          index: 4,
          path: "ai",
          name: "技能中心",
          icon: "iconfont icon-jinengzhongxin",
          roles: ["admin"],
          children: [
            {
              index: 401,
              path: "generalSkill",
              name: "通用技能",
              roles: ["admin"],
            },
            { index: 402, path: "face", name: "人脸库管理", roles: ["admin"] },
            { index: 403, path: "car", name: "车牌库管理", roles: ["admin"] },
            // {
            //   index: 404,
            //   path: "skill",
            //   name: "技能管理",
            //   icon: "iconfont icon-jinengzhongxin",
            //   roles: ["admin"],
            //   children: [
            //     {
            //       index: 4041,
            //       path: "skill_admin/model/index",
            //       name: "模型管理",
            //       roles: ["admin"]
            //     },
            //     {
            //       index: 4042,
            //       path: "skill_admin/plugin/index",
            //       name: "技能插件管理",
            //       roles: ["admin"]
            //     },
            //     // {
            //     //   index: 4043,
            //     //   path: "skill3",
            //     //   name: "技能配置管理",
            //     //   roles: ["admin"]
            //     // },
            //     {
            //       index: 4044,
            //       path: "skill_admin/sku/index",
            //       name: "SKU信息表",
            //       roles: ["admin"]
            //     },
            //     {
            //       index: 4045,
            //       path: "skill_admin/support/index",
            //       name: "设备支持技能配置",
            //       roles: ["admin"]
            //     }
            //     // {
            //     //   index: 4046,
            //     //   path: "skill6",
            //     //   name: "技能版本映射表",
            //     //   roles: ["admin"]
            //     // }
            //     //     // {
            //     //     //   index: 4047,
            //     //     //   path: "skill7",
            //     //     //   name: "技能升级配置表",
            //     //     //   roles: ["admin"]
            //     //     // }
            //   ]
            // }
          ],
        },
        {
          index: 5,
          path: "set",
          name: "系统设置",
          icon: "iconfont icon-shebeiguanli",
          roles: ["editor"],
          children: [
            {
              index: 501,
              path: "generalSetting",
              name: "通用设置",
              roles: ["admin"],
            },
            {
              index: 502,
              path: "currentConfig",
              name: "当前配置",
              roles: ["admin"],
            },
            {
              index: 503,
              path: "haikangConfig",
              name: "海康iSC平台参数配置",
              roles: ["admin"],
            },
          ],
        },
        // {
        //   index: 6,
        //   path: "user",
        //   name: "成员管理",
        //   icon: "iconfont icon-shebeiguanli",
        //   roles: ["admin"]
        // }
      ],
      deviceTypes: "",
      allSkills: [],
      allowClick: false,
    };
  },
  created() {
    this.initOpenKey();
    this.gotoPage();
    this.getPath();
  },
  mounted() {
    if (this.$router.name == "login") {
      return;
    }
    if (!global || !global.userInfo) {
      return this.logOut();
    }
    $(".main-head-popover").hover(
      () => {
        this.showPanel = true;
        this.$nextTick(() => {
          this.setUserHeader(this.m);
        });
      },
      () => {
        this.showPanel = false;
      }
    );
    this.addUserMenu();
  },
  computed: {
    menuWidth: function () {
      return this.mWidth + "px";
    },
    msgVisible: function () {
      return process.env.NODE_ENV != "private";
    },
  },
  methods: {
    // 退出登录
    logOut() {
      global.logOut(this);
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 获取当前路径
    getPath() {
      const {
        $route: { name },
      } = this;
      if (name == "generalSkill") {
        this.$router.push("/ai/generalSkill");
        this.selectedKeys = this.$route.name.split(",");
      } else if (name == "event") {
        this.selectedKeys = decodeURI(this.$route.path).split("/").splice(2, 1);
      }
      // else if(name === ) {

      // }
      else {
        this.selectedKeys = this.$route.name.split(",");
      }
    },
    gotoPage() {
      var that = this;
      var qid = global.getCookie("main_header_account");
      if (!global.qid) {
        global
          .axios(this, global.ajaxAdd.checkUser, {
            account_qid: global.userInfo.qid,
          })
          .then((res) => {
            global.accountList = res.data;
            var user_data = null;
            for (var i = 0; i < res.data.length; i++) {
              if (res.data[i].qid == qid) {
                user_data = res.data[i];
                break;
              }
            }
            if (res.data.length > 0) {
              if (!user_data) {
                user_data = res.data[0];
              }
              global.user_level = user_data.user_level;
              this.qid = global.qid = user_data.qid;
              this.isAdmin();
              this.getDeviceTypes();
              this.getMessageInfo();
            } else {
              //   this.alertShow = true;
              global.msg(this, "账号不存在", "error");
              this.logOut();
            }
          })
          .catch((e) => {
            this.logOut(e);
          });
      } else {
        this.currentAccount = qid || global.qid;
        this.accountList = global.accountList;
        this.showHeader = true;
        this.isAdmin();
      }
    },
    gotoLoginPage() {
      global.isJumpingToLogin = null;
      global.userInfo = null;
      global.qid = null;
      global.gotoLoginPage(this);
    },
    getDeviceTypes() {
      if (!global.qid) {
        return;
      }
      var that = this;
      global
        .axios(this, global.ajaxAdd.getProductList, {
          account_qid: global.userInfo.qid,
          qid: global.qid,
        })
        .then((res) => {
          that.deviceTypes = res.data;
          that.getDeviceSkill();
        });
    },
    // 获取技能列表
    // getDeviceSkill () {
    //   let data = {
    //     qid: global.qid,
    //     account_qid: global.userInfo.qi,
    //     product_id: this.deviceTypes[1].product_id,
    //     type: 1,
    //   }
    //   global.axios(this, global.ajaxAdd.getDeviceSkill, data).then((res) => {
    //     if (res.data) {
    //       let skillid = []
    //       let skillName = []
    //       let skillList = []
    //       let skillData = res.data.skill_config[2]
    //       skillData.forEach(item => {
    //         let data = JSON.parse(item.skill_data)
    //         if (item.skill_id != 9999) {
    //           skillid.push(item.skill_id)
    //         }
    //         skillName.push(data)
    //       })
    //       for (var i = 0; i < skillName.length; i++) {
    //         for (var j = 0; j < skillName[i].length; j++) {
    //           if (skillName[i][j].param_name == "skill_name") {
    //             var obj = {}
    //             obj.skill_id = skillid[i]
    //             obj.skill_name = skillName[i][j].param_title
    //             skillList.push(obj)
    //           }
    //         }
    //       }
    //       this.skillIdList = skillid
    //       this.skillList = skillList
    //       let w = (skillid.length * (1.21875 + 0.125) - 0.125) + 'rem'
    //       this.$nextTick(() => {
    //         $('.nav-list').css({ 'width': w })
    //       })
    //       this.getDataToday()
    //       this.getAlaramTrendData()
    //       this.getAlarmTop()
    //     }
    //   }).catch((e) => {
    //   })
    // },
    getDeviceSkill() {
      var pid = "";
      if (this.deviceTypes[1] && this.deviceTypes[1].product_id) {
        pid = this.deviceTypes[1].product_id;
      }
      var data_ = {
        product_id: pid,
        type: 1,
        account_qid: global.userInfo.qid,
        qid: global.qid,
      };
      global
        .axios(this, global.ajaxAdd.getDeviceSkill, data_)
        .then((res) => {
          // var temp = global.parseSkillData(skillList, res.data)
          // var allSkills = JSON.parse(JSON.stringify(temp))
          let skillid = [];
          let skillName = [];
          let skillList = [];
          let skillData = res.data.skill_config[2];
          skillData.forEach((item) => {
            let data = JSON.parse(item.skill_data);
            if (item.skill_id != 9999) {
              skillid.push(item.skill_id);
            }
            skillName.push(data);
          });
          for (var i = 0; i < skillName.length; i++) {
            for (var j = 0; j < skillName[i].length; j++) {
              if (skillName[i][j].param_name == "skill_name") {
                for (var k = 0; k < skillName[i].length; k++) {
                  if (skillName[i][k].param_name == "skill_show") {
                    if (skillName[i][k].param_val == true) {
                      var obj = {};
                      obj.skill_id = skillid[i];
                      obj.skill_name = skillName[i][j].param_title;
                      skillList.push(obj);
                    }
                  }
                }
              }
            }
          }
          global.allSkills = skillList;
          for (var i = 0; i < skillList.length; i++) {
            let item = {
              index: "30" + skillList[i].skill_id,
              path: skillList[i].skill_name,
              name: skillList[i].skill_name,
            };
            this.allSkills.push(item);
          }
          this.menu[3].children = this.allSkills;
          global.menuEvent = this.allSkills;
          this.allowClick = true;
          window.sessionStorage.setItem(
            "more",
            "/event/" + this.allSkills[0].name
          );
          // this.setSkills(JSON.parse(JSON.stringify(temp)))
        })
        .catch((e) => {
          this.allowClick = true;
          // this.logout(e)
        });
    },
    setUserHeader(qid) {
      for (var i = 0; i < this.d.length; i++) {
        if (this.d[i].qid == qid) {
          var item = this.d[i];
          if (!item.hasOwnProperty("expire_status")) {
            var arr = item.expire_time.split("-");
            if (isSafari) {
              item.expire_time = arr.join("/");
            }
            // debugger
            var expire_time = item.expire_time;

            if (item.expire_time.indexOf(" ") == -1) {
              expire_time = item.expire_time + " 23:59:59";
            }
            var d_ = new Date(expire_time).getTime();
            var n_ = new Date().getTime();
            var c_ = d_ - n_;
            if (c_ > 3600 * 24 * 1000 * 7) {
              //大于一周
              item.expire_status = 1;
            } else if (c_ > 0 && c_ <= 3600 * 24 * 1000 * 7) {
              //小于一周
              item.expire_status = 2;
            } else {
              item.expire_status = 3;
            }
          }
          this.user = item;
          break;
        }
      }
    },
    boxChange(e) {
      window.sessionStorage.clear();
      this.qid = e;
      global.qid = e;
      window.sessionStorage.setItem("qid", e);
      this.getProductList(e, global.userInfo.qid);
      this.isManager = false;
      for (var i = 0; i < this.d.length; i++) {
        if (this.d[i].qid == e) {
          if (this.d[i].is_owner == 1) {
            this.isManager = true;
          }
          //是否是试用者身份
          global.user_level = this.d[i].user_level;
          break;
        }
      }
      this.setUserHeader(e);
      this.$emit("accountChange");
      this.gotoPage();
    },
    // 获取产品列表
    getProductList(qid, account_qid) {
      let data = {
        qid: qid,
        account_qid: account_qid,
      };
      global.axios(this, global.ajaxAdd.getProductList, data).then((res) => {
        if (res.data) {
          res.data.forEach((item) => {
            if (item.type == 2) {
              window.sessionStorage.setItem("productId", item.product_id);
            }
          });
        }
      });
    },
    gotoUser() {
      this.$router.push("user");
    },
    getIndex() {
      var menuIndex = global.getMenuIndex(this.$route.path);
      return menuIndex;
    },
    resize() {
      this.mWidth = window.innerWidth - 440;
      if (this.$refs.container && this.$refs.container.resize) {
        this.$refs.container.resize();
      }
    },
    confirm(e) {
      this.logOut();
    },
    cancel(e) {},
    changeSelect(e) {
      this.menuIndex = e.key;
    },
    // menu跳转
    handelClickLink(item) {
      this.$router.push("/" + item.path);
      this.scrollTop();
    },
    // 滚动条置顶
    scrollTop() {
      $(".main-container")[0].scrollTop = 0;
    },
    //清除所有cookie函数
    clearAllCookie() {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--; )
          document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
      }
    },
    initOpenKey() {
      this.openKeys = this.keepKeys = this.$route.path.split("/").splice(1, 1);
    },
    // 导航状态（展开-收起）改变时函数
    collapseMenu(e) {
      this.collapsed = !this.collapsed;
      if (this.collapsed) {
        this.openKeys = [""];
      } else {
        this.openKeys = this.keepKeys;
      }
    },
    // 点击一级菜单获取当前选中菜单的key值
    menuClick(e) {
      if (process.env.NODE_ENV == "private" && e.path == "user") {
        return (window.location.href =
          "http://10.175.160.25:83/user/auth/identitymange/member");
      }
      this.openKeys = [""];
      this.keepKeys = e.path.split(",");
      this.$router.push("/" + e.path);
    },
    // 点击二级菜单获取当前选中菜单所属一级菜单的key值
    keepOpenKeys(item, subItem) {
      // this.keepKeys = item.path.split(',')
      this.$router.push("/" + item.path + "/" + subItem.path);
    },
    keepOpenKeys1(item, subItem, subItem1) {
      // this.keepKeys = item.path.split(',')
      this.$router.push("/" + item.path + "/" + subItem1.path);
    },
    onOpenChange(openKeys) {
      // 当菜单被展开时触发此处
      /*
      经测试传入的变量openKeys是数组 点击已经展开的菜单时传入的是空数组
      点击未展开的菜单时传入的是[当前展开菜单的key,点击的菜单key]
      下面的if判断用openKeys === [] 无效 所以我只能判断数组length是否等于0
      */
      if (!this.allowClick) {
        return false;
      }
      if (openKeys.length !== 0) {
        if (
          openKeys[1] == "event" &&
          this.allSkills.length == 0 &&
          process.env.NODE_ENV != "private"
        ) {
          return this.$message.error(
            "您尚未开通此功能，立即体验请联系 g-bpd-sdk@360.cn"
          );
        }
        this.openKeys = [openKeys[1]];
      } else {
        this.openKeys = [""];
      }
    },
    // 获取开关状态
    getSettingStatus() {
      var qid = global.getCookie("main_header_account");
      let data = {
        qid: qid || global.qid,
        account_qid: global.info,
      };
      global.axios(this, global.ajaxAdd.getSettingInfo, data).then((res) => {
        if (res) {
          this.defaultChecked = res.data[0].status == 1 ? true : false;
        }
      });
    },
    // 获取站内信未读消息数
    getMessageInfo() {
      let data = {
        qid: global.qid,
        account_qid: global.userInfo.qid,
      };
      global.axios(this, global.ajaxAdd.getNewsCount, data).then((res) => {
        if (res && res.data) {
          let count = res.data.count;
          this.$store.commit("changeMsgCount", count);
        }
      });
    },
    // 点击消息跳转到消息页
    toMessage() {
      this.$router.push({ path: "/message" });
    },
    addUserMenu() {
      if (process.env.NODE_ENV != "private") {
        this.menu.forEach((item, i) => {
          if (item.name == "成员管理") {
            this.menu.splice(i, 1);
          }
        });
      }
    },
    isAdmin(currentQid){
      var qid = global.getCookie("main_header_account");
        global.axios(this, global.ajaxAdd.isAdmin,{
          account_qid: global.userInfo.qid,
          qid: currentQid ? currentQid : (qid || global.qid)
        }).then(res => {
        if (res.errno === 0) {
            // 是管理员，菜单去掉公共插件管理 todo
              this.menu = this.menu.map((item, i) => {
              if (item.path == "ai-plugin") {
                  item.children= [
                      {
                        index: 802,
                        path: "custom-public-plugin",
                        name: "公共插件",
                        roles: ["admin"]
                      },
                      {
                        index: 801,
                        path: "custom-plugin-list",
                        name: "我的插件",
                        roles: ["admin"]
                      },
                      {
                        index: 803,
                        path: "custom-public-pluginManage",
                        name: "公共插件管理",
                        roles: ["admin"]
                      }
                  ]; 
              }
              return item
          });

        }
      });
    }
  },
  watch: {
    //动态监听路由变化 -以便动态更改导航背景色事件效果等
    $route(to, from) {
      const { path, name } = to;
      // 对路由变化作出响应...
      this.openKeys = this.keepKeys = path.split("/").splice(1, 1);
      if (name == "event") {
        this.selectedKeys = path.split("/").splice(2, 1);
      }
      else if(path.includes('/template/screenshot')) {
        this.selectedKeys = ['screenshot-template-list'];
      }
      // else if(path.includes('/ai-plugin') || path.includes('-custom-plugin')) {
      //   this.selectedKeys = ['custom-plugin-list'];
      // }
      else if(path === '/ai-plugin/custom-plugin-list' || path === '/ai/create-custom-plugin' || path.includes( '/ai/update-custom-plugin')){
        this.selectedKeys = ['custom-plugin-list'];
      } 
      else if(path.includes('public-pluginManage')){
        this.selectedKeys = ['custom-public-pluginManage'];
      }
      else if(path.includes('structured-')) {
        this.selectedKeys = ['structured-libs-list'];
      }
      else {
        this.selectedKeys = name.split(",");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main-head-popover {
  position: relative;
}

.main-head-hover {
  position: absolute;
  width: 270px;
  height: 180px;
  background: #fff;
  box-shadow: 4px 4px 5px #888888;
  right: -80px;
  border-radius: 4px;
}
.main-head-hover-1 {
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgb(218, 216, 216);
  padding-left: 10px;
}
.main-head-hover-1 span {
  margin-left: 10px;
}
.main-head-hover-2,
.main-head-hover-3,
.main-head-hover-4 {
  padding-left: 20px;
  line-height: 22px;
  margin-bottom: 0;
  margin-top: 10px;
}
.main-head-hover-3 {
  display: flex;
  align-items: center;
}
.main-head-hover-5 {
  position: absolute;
  bottom: 10px;
  right: 30px;
}
.main-head-hover-2 {
  margin-top: 20px;
}
.main-head .ant-select-selection {
  background: 0;
  border: 0;
}
.main-head .ant-select,
.main-head .ant-select,
.main-head .ant-select-arrow {
  font-family: PingFang SC;
  font-size: 12px;
  color: #666666;
  text-align: center;
  letter-spacing: 0;
  line-height: 17px;
  /deep/ .ant-select-selection {
    min-width: 120px;
    border: none !important;
    background: #f7f7f8;
    .ant-select-selection__rendered {
      float: right;
    }
  }
}
.main-head {
  height: 50px;
  position: absolute;
  right: 20px;
  top: 0;
  z-index: 21;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
/deep/ .main-head .ant-select-selection.ant-select-selection--single {
}
/deep/ .main-head .ant-select-selection-selected-value {
  margin-right: 10px;
}
.main-head-name {
  max-width: 100px;
  color: #fff;
  line-height: 50px;
  height: 50px;
  margin: 0 0 0 10px;
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.main-head-line {
  margin: 0 14px;
  display: inline-block;
  color: #ddd;
}
.main-head-quit {
  width: 40px;
}
.ant-menu-inline-collapsed {
  width: 60px !important;
}
.main-menu-sider {
  flex: 0 0 60px !important;
  max-width: 60px !important;
  min-width: 60px !important;
  width: 60px !important;
}
.main-container {
  background: #f4f9ff;
  overflow: auto !important;
  // overflow-y: scroll !important;
}
.home {
  .sider {
    // position: fixed;
    z-index: 40;
    width: 200px;
    height: 100vh;
    background: #1d2237;
    .menu {
      height: calc(100vh - 50px);
      overflow: auto;
      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-thumb {
        background: #535353;
      }
      &::-webkit-scrollbar-track {
        background: #1d2237;
      }
    }
    .logo {
      width: 100%;
      height: 50px;
      background: url(https://p2.ssl.qhimg.com/t01a2fafb5ef501bf3c.png)
        no-repeat center;
      background-size: 120px;
      background-color: #121625;
    }
    .collapsed {
      width: 32px;
      margin: 0 auto;
      background: url(https://p2.ssl.qhimg.com/t01a2fafb5ef501bf3c.png)
        no-repeat center;
      background-size: 120px;
      background-position: 0;
    }
    .ant-menu {
      background: #0b0f1d;
      .ant-menu-item,
      /deep/ .ant-menu-submenu-title {
        height: 48px;
        margin: 0;
        padding: 0 0 0 30px !important;
        line-height: 48px;
        .iconfont {
          margin: 0 12px 0 0;
        }
      }
      .ant-menu-item-selected {
        background-color: #007aff;
      }
      .ant-menu-submenu-open {
        background: #101629;
        /deep/ .ant-menu-sub {
          background: #101629;
          box-shadow: none;
        }
      }
      .ant-menu-submenu {
        .ant-menu-item {
          padding: 0 0 0 63px !important;
        }
      }
    }
    .ant-menu-inline-collapsed {
      width: 60px;
      .ant-menu-item,
      /deep/ .ant-menu-submenu-title {
        padding: 0 0 0 22px !important;
      }
      .ant-menu-item,
      .ant-menu-submenu {
        .iconfont ~ span {
          opacity: 0;
        }
      }
    }
  }
  /deep/ .ant-layout-sider-trigger {
    background: #121625;
  }
  .ant-tooltip {
    .ant-tooltip-content {
      .ant-tooltip-inner {
        .iconfont {
          display: none;
        }
      }
    }
  }
  .main {
    padding-top: 0 !important;
    min-height: 100%;
    min-width: 760px;
    .header {
      position: relative;
      z-index: 40;
      width: 100%;
      height: 50px;
      padding: 0 22px;
      line-height: 50px;
      background: #f7f7f8;
      box-shadow: 0 2px 3px 0 #0000001a;
      .top-nav-content {
        margin-right: 20px;
        a,
        span {
          display: inline-block;
          padding: 0 15px;
          color: #666;
          font-size: 12px;
          line-height: 50px;
          text-align: center;
          cursor: pointer;
          user-select: none;
        }
        .message {
          /deep/ .ant-badge-count {
            top: 14px;
            right: 10px;
            p {
              color: #fff;
              font-size: 12px;
            }
          }
        }
      }
      .trigger {
        font-size: 14px;
      }
    }
    .main-header {
      background: #030507 !important;
      .top-nav-content {
        a,
        span {
          color: #d9d9d9;
        }
      }
      .company-content {
        .company-select {
          .company-select-item {
            .company-select-name {
              color: #f7f7f8;
            }
            .icon-down {
              color: #f7f7f8;
            }
          }
        }
        .company-list {
          border: none;
          box-shadow: none;
        }
      }
      /deep/ .ant-select-selection {
        color: #d9d9d9;
        background-color: #030507;
        border: none;
      }
      /deep/ .ant-select-arrow {
        color: #d9d9d9;
      }
      .trigger {
        font-size: 14px;
        color: #f7f7f8;
      }
    }
  }
}
.ant-tooltip {
  .ant-tooltip-content {
    .ant-tooltip-inner {
      .iconfont {
        display: none;
      }
    }
  }
}
.company-content {
  position: relative;
  height: 50px;
  margin: 0 20px 0 0;
  cursor: pointer;
  &:hover {
    .company-list {
      display: block;
    }
  }
  .company-select {
    .company-select-item {
      margin: 0;
      .company-select-name {
        color: #666;
        font-size: 12px;
        line-height: 50px;
      }
      .icon-down {
        margin-left: 5px;
        color: #666;
        font-size: 10px;
      }
    }
  }
  .company-list {
    position: absolute;
    left: -30px;
    width: 240px;
    display: none;
    max-height: 290px;
    padding: 10px 0;
    overflow: auto;
    background: #fff;
    border: 1px solid #eee;
    box-shadow: 0 0 10px #eee;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background: #bbb;
    }
    &::-webkit-scrollbar-track {
      background: #fff;
    }
    .company-id {
      display: block;
      height: 24px;
      padding: 0 10px;
      color: #666;
      font-size: 12px;
      line-height: 24px;
    }
    .company-item {
      display: block;
      height: 36px;
      padding: 0 15px;
      margin: 0;
      line-height: 36px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
/deep/.ant-badge-count {
  display: block;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/main/Home.vue